export function getBaseApiUrl(): string | undefined {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'development':
      return 'http://localhost:3000';
    case 'local':
      return 'http://localhost:3000';
    case 'production':
      return 'https://sensejs-server.flex-charge.com';
    case 'sandbox':
      return 'https://sandbox-sensejs-server.flex-charge.com';
    case 'staging':
    case 'default':
      return 'https://sensejs-staging.flex-charge.com';
  }
}

export function getCoreAPIUrl(route: string): string | undefined {
  if (process.env.REACT_APP_ENVIRONMENT === 'development' && process.env.REACT_APP_DEV_ENVIRONMENT === 'local') {
    switch (route) {
      case 'tokenize':
        return 'http://localhost:5022/PaymentInstruments';
      case 'auth':
        return 'http://localhost:5279/oauth2/token';
      case 'evaluate':
        return 'http://localhost:5013/evaluate';
      case 'eligibility':
        return 'http://localhost:5013';
      case 'configuration':
        return 'http://localhost:5301';
      case 'orders':
        return 'http://localhost:5003';
    }
  }

  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'development':
      return 'https://api-staging.flex-charge.com/v1';
    case 'production':
      return 'https://api.flex-charge.com/v1';
    case 'sandbox':
      return 'https://api-sandbox.flex-charge.com/v1';
    case 'staging':
    case 'default':
      return 'https://api-staging.flex-charge.com/v1';
  }
}

export const BASE_URL = {
  TRACKING:
    process.env.REACT_APP_ENVIRONMENT === 'development' && process.env.REACT_APP_DEV_ENVIRONMENT === 'local'
      ? 'http://localhost:5301/tracking'
      : `${getCoreAPIUrl('configuration')}`,
  CONFIGURATION:
    process.env.REACT_APP_ENVIRONMENT === 'development' && process.env.REACT_APP_DEV_ENVIRONMENT === 'local'
      ? 'http://localhost:5301/configuration'
      : `${getCoreAPIUrl('configuration')}/configuration`,
  LINK_NEXT:
    // process.env.REACT_APP_ENVIRONMENT === 'development' && process.env.REACT_APP_DEV_ENVIRONMENT === 'local'
    //   ? 'http://localhost:5003/public/Links/next'
    //   : `${getCoreAPIUrl('orders')}/public/Links/next`,
    process.env.REACT_APP_ENVIRONMENT === 'development' && process.env.REACT_APP_DEV_ENVIRONMENT === 'local'
      ? 'http://localhost:5003/Links/next'
      : `${getCoreAPIUrl('orders')}/links/next`,
};

export function getTokenexApiUrl(): string | undefined {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'production':
      return 'https://api.tokenex.com/v2/ThreeDSecure/ChallengeResults';
    case 'development':
    case 'local':
    case 'sandbox':
    case 'staging':
    case 'default':
      return 'https://test-api.tokenex.com/v2/ThreeDSecure/ChallengeResults';
  }
}
